export default __webpack_public_path__ + "static/media/AutoFlow_bg.1f947baa.jpg";